/*
 * @Author: Nora Galvin
 * @Date: 2020-08-17 10:49:38
 * @Last Modified by: Felixx
 * @Last Modified time: 2020-11-09 09:43:50
 */
import template from '@/app/editor/sidebar/templates/gfElement/image.html';

export const imageSettings = [
  {
    name: 'image-wrapper',
    caption: 'Image',
    type: 'group',
    items: [
      {
        name: 'image',
        type: 'text',
        class: 'gf_to-photoPicker',
        target: '.gf_image',
        ref: 'attr|src',
      },
      {
        id: 'image-size',
        name: 'image-size',
        caption: 'Image Resolution',
        desc: 'Only support for UCare CDN and Shopify CDN',
        type: 'select',
        options: {
          '100x100': '100x100',
          '240x240': '240x240',
          '480x480': '480x480',
          '576x576': '576x576',
          '640x640': '640x640',
          '768x768': '768x768',
          '800x800': '800x800',
          '960x960': '960x960',
          '1024x1024': '1024x1024',
          '1280x1280': '1280x1280',
          '1440x1440': '1440x1440',
          '1600x1600': '1600x1600',
          '1920x1920': '1920x1920',
          '2560x2560': '2560x2560',
          '3000x3000': '3000x3000',
        },
        default_value: '2560x2560',
      },
    ],
    advanced: [
      {
        name: 'title',
        id: 'title',
        caption: 'Title',
        type: 'text',
        default_value: '',
        desc: 'Show title when hover to image',
        target: '.gf_image',
        ref: 'attr|title',
      },
    ],
  },
  {
    caption: 'Dimension',
    type: 'group',
    mode: 'responsive-mode',
    items: [
      {
        name: 'width',
        id: 'width',
        caption: 'Width',
        type: 'text',
        default_value: '100%',
        mode: 'responsive-mode',
        target: '.gf_image',
        ref: 'css|width',
      },
      {
        name: 'height',
        id: 'height',
        caption: 'Height',
        type: 'text',
        default_value: 'auto',
        mode: 'responsive-mode',
        target: '.gf_image',
        ref: 'css|height',
      },
      {
        name: 'circle',
        id: 'circle',
        class: 'gf_to-switch',
        caption: 'Circle Image',
        type: 'input',
        default_value: '0',
      },
    ],
  },
  {
    caption: 'Link',
    type: 'group',
    items: [
      {
        name: 'editLink',
        caption: 'Image Link',
        type: 'text',
        class: 'editLink',
        placeholder: 'https://your-shop.myshopify.com',
        default_value: '',
        target: '.elm a',
        ref: 'attr|href',
      },
      {
        id: 'url-target',
        name: 'url-target',
        caption: 'Open link In',
        type: 'select',
        options: {
          '': 'Current Tab',
          _blank: 'New Tab',
        },
        default_value: '',
        target: '.elm a',
        ref: 'attr|target',
      },
    ],
  },
  {
    name: 'alt-tag',
    caption: 'Alt Tag',
    placeholder: 'Your alt tags go here',
    type: 'text',
    desc: 'Each image should have an alt text. Not just for SEO purposes but also because blind and visually impaired people otherwise wont know what the image is for.',
    target: '.gf_image',
    ref: 'attr|alt',
  },
  {
    name: 'alignment',
    id: 'alignment',
    caption: 'Alignment',
    type: 'select',
    class: 'gf_to-align',
    options: {
      left: 'Left',
      center: 'Center',
      right: 'Right',
    },
    default_value: '',
    mode: 'responsive-mode',
    target: '.elm',
    ref: 'class|align',
  },
  {
    name: 'extra_class',
    caption: 'Extra Class',
    type: 'text',
    desc: 'If you wish to style particular content element differently, then use this field to add a class name and then refer to it in your css file.',
    target: '.elm',
    ref: 'class|classname',
  },
];

export default {
  name: 'Image',
  slug: 'image',
  class: 'gf_image',
  id: 'md-image',
  html: template(),
  settings: imageSettings,
};
